module.exports = {
    config: {
        tableComponentClass: 'templates_core_table_table',
        controllerComponentClass: 'templates_core_controller_controller'
    },

    model: {
        nrOfElementsAttributes: {},
        nrOfSelectedElements: 0
    },

    methods: {
        prepare: function(storage, isServer){
            if(!isServer){
                var self = this;
                self.closest(self.config.controllerComponentClass, function(controller){
                    controller.find(self.config.tableComponentClass, function(table){
                        self.model.nrOfElementsAttributes = ((table.resourceData.nrOfElements || {}).data || {}).attributes || {};
                        self.model.nrOfElementsAttributes.nrOfVisibleElements = Object.keys(table.model.entityList || {}).length || 0;
                    });
                });
            }
        }
    },
};
